import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 14.083c0 4.154 -2.966 6.74 -7 6.917c-4.2 0 -7 -2.763 -7 -6.917c0 -5.538 3.5 -11.09 7 -11.083c3.5 .007 7 5.545 7 11.083","key":"svg-0"}]]

/**
 * IconEgg
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZWdnIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xOSAxNC4wODNjMCA0LjE1NCAtMi45NjYgNi43NCAtNyA2LjkxN2MtNC4yIDAgLTcgLTIuNzYzIC03IC02LjkxN2MwIC01LjUzOCAzLjUgLTExLjA5IDcgLTExLjA4M2MzLjUgLjAwNyA3IDUuNTQ1IDcgMTEuMDgzIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/egg
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconEgg = createReactComponent('outline', 'egg', 'Egg', __iconNode);

export default IconEgg;